import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

const Cards = styled.div`
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  display: grid;
  grid-gap: ${tokens.space.regular};
`;

export default Cards;
